<!-- PAGE CONTENT WRAPPER -->
<div class="page-content-wrap contentdata">
  <!-- Contenet page started-->
  <div class="row">
    <div [hidden]="pgLoad">
      <div class="adjust loader-container">
        <div class="loader2"></div>
      </div>
    </div>
    <div class="col-md-12" [hidden]="!pgLoad">
      <!-- breadcrumb -->
      <div class="page-breadcrumb">
        <ul class="page-breadcrumb__trail">
          <li><a>Charts</a></li>
          <li><a>Trend Analysis</a></li>
          <li><a>Actual Vs Projected</a></li>
        </ul>
        <div class="page-breadcrumb__icons">
          <a routerLink="/home"><img src="assets/images/New_Icons/home-transprent-icon.svg" title="Home"></a>
        </div>
      </div>
      <!-- breadcrumb End -->
      <div class="block">
        <div class="page-header">
          <span class="page-header__title">Actual Vs Projected</span>
        </div>
        <div class="Reports_form_div">
          <form role="form" name="addmapdevice" [formGroup]="registerForm">
            <div class="reports-form-container" (clickOutside)="isDropdownOpen = false">
              <mat-form-field appearance="outline" class="w-100 custom-select" *ngIf="loginPersonType == 'EMPLOYEE'">
                <mat-label>Search Business Name</mat-label>
                <!-- search box powered by mat‑autocomplete -->
                <input matInput type="text" id="businessname" autocomplete="off" formControlName="businessfield" placeholder="Search business" (keyup)="filterBusinesses($event)"
                       (click)="isDropdownOpen = true" (focus)="filteredOptions = businessEntites" [matAutocomplete]="businessAuto"/>
                <mat-autocomplete #businessAuto="matAutocomplete" (optionSelected)="selectOption($event.option.value)">
                  <mat-option *ngFor="let option of filteredOptions" [value]="option">
                    {{ option.businessName }}
                  </mat-option>
                </mat-autocomplete>
                <mat-hint *ngIf="f.businessfield.invalid"><i>Select business</i></mat-hint>
                <mat-hint *ngIf="f.businessfield.valid"><i>Business selected</i></mat-hint>
                <mat-error *ngIf="(submitted || f.businessfield.touched || f.businessfield.dirty) && f.businessfield.errors">
                  <i *ngIf="f.businessfield.hasError('required')">Required.</i>
                </mat-error>
              </mat-form-field>
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Farm Site</mat-label>
                <mat-select id="location" formControlName="locationField" name="location" (click)="isDropdownOpen = false" [(ngModel)]="feedRate.farm_site_id"
                            (selectionChange)="getSetionsByFarmsiteId(feedRate.farm_site_id)">
                  <mat-option value="undefined" disabled>Select Farm site</mat-option>
                  <mat-option *ngFor="let farmsite of farmsites" [value]="farmsite.id">
                    {{ (farmsite?.farmNameAtLocation)}}
                  </mat-option>
                </mat-select>
                <mat-hint *ngIf="f.locationField.invalid"><i>Select farm site</i></mat-hint>
                <mat-hint *ngIf="f.locationField.valid"><i>Farm site selected</i></mat-hint>
                <mat-error *ngIf="(submitted || f.locationField.touched || f.locationField.dirty) && f.locationField.errors">
                  <i *ngIf="f.locationField.hasError('required')">Required.</i>
                </mat-error>
              </mat-form-field>
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Section</mat-label>
                <mat-select id="sectionField" formControlName="sectionField" name="sectionField" (click)="isDropdownOpen = false" [(ngModel)]="feedRate.section_id"
                            (selectionChange)="getPondsBySectionId(feedRate.section_id)">
                  <mat-option value="undefined" disabled>Select Section</mat-option>
                  <mat-option *ngFor="let sections of pondSections" [value]="sections.id">
                    {{ (sections?.section_name)}}
                  </mat-option>
                </mat-select>
                <mat-hint *ngIf="f.sectionField.invalid"><i>Select section</i></mat-hint>
                <mat-hint *ngIf="f.sectionField.valid"><i>Section selected</i></mat-hint>
                <mat-error *ngIf="(submitted || f.sectionField.touched || f.sectionField.dirty) && f.sectionField.errors">
                  <i *ngIf="f.sectionField.hasError('required')">Required.</i>
                </mat-error>
              </mat-form-field>
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Pond</mat-label>
                <mat-select id="pondField" formControlName="pondField" name="pondField" (click)="isDropdownOpen = false" [(ngModel)]="feedRate.pond_id">
                  <mat-option value="undefined" disabled>Select Pond</mat-option>
                  <mat-option *ngFor="let pond of activepondsDetails_dropdown" [value]="pond.pond_id">
                    {{ (pond?.pond_name)}}
                  </mat-option>
                </mat-select>
                <mat-hint *ngIf="f.pondField.invalid"><i>Select pond</i></mat-hint>
                <mat-hint *ngIf="f.pondField.valid"><i>Pond selected</i></mat-hint>
                <mat-error *ngIf="(submitted || f.pondField.touched || f.pondField.dirty) && f.pondField.errors">
                  <i *ngIf="f.pondField.hasError('required')">Required.</i>
                </mat-error>
              </mat-form-field>
              <p style="color: red"
                 *ngIf="activepondsDetails_dropdown && activepondsDetails_dropdown.length == 0 && feedRate.section_id != undefined">
                Tanks are not available for this site</p>
            </div>
          </form>
          <div class="buttons-div reports_search_div">
            <div class="transactions-button-container" (click)="formsubmit()">
              <button class="transaction-submit-button" [disabled]="submitButtonDisabled">
                <span class="icon"><img src="../../../../../../../assets/images/New_Icons/search-icon.svg"></span>
                <span class="text">Search</span>
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-xs-12" [hidden]="!isSearchClicked">
          <div class="col-xs-4">
            <p class="graph_heading">Feed Trend Analysis</p>
          </div>
          <div class="col-xs-4">
            <p class="graphHeading">Actual ( <img src="../../../../assets/img/ac-dtf.png" width="40px"> ) <span
              class="vsclass">Vs</span> Projected ( <img src="../../../../assets/img/pf-dtf.png" width="40px"> )
            </p>
          </div>
          <div class="col-xs-4">
            <p class="graph-arrows">
              <img src="../../../../assets/img/left-arrow-graph.png" class="left-arrows"
                   width="20px" [hidden]="paginationOffset==0" (click)="getPrevComparisionData()">
              <img src="../../../../assets/img/right_arrow_graph.png" id="nextPagination"
                   class="graph-arrows ion-float-right" width="20px"
                   [hidden]="limit>= (actualCumulativeFeed && actualCumulativeFeed.length)"
                   (click)="getNextComparisionData()">
            </p>
          </div>
          <div class="x_chart_panel">
            <div class="x_content">
              <canvas #cumulativeFeedComparisionCanvas></canvas>
            </div>
          </div>
        </div>
      </div>
      <!-- End farm spend grid-->
    </div>
  </div>
</div>

